import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { StoreOrderDetailPanel } from "../../customer_account/StoreOrderDetailPanel";
import { TactikSiteTopBar } from "../app/TactikSiteTopBar";
import { getStandaloneSpaceId } from "../config";
import "../../customer_account/AccountPage.css";

export default function OrderDetailPage(): JSX.Element | null {
  const { orderId } = useParams<{ orderId: string }>();
  const spaceId = getStandaloneSpaceId();
  const navigate = useNavigate();
  const onMissingParams = useCallback(() => navigate("/tactik/orders"), [navigate]);

  if (!spaceId || !orderId) {
    return null;
  }

  return (
    <div className="customer-account-page">
      <TactikSiteTopBar />
      <main className="customer-account-page__main customer-account-page__main--order-detail">
        <StoreOrderDetailPanel
          spaceId={spaceId}
          orderId={orderId}
          scope="standalone"
          onMissingParams={onMissingParams}
        />
      </main>
    </div>
  );
}
